export class User{
    id: string;
    nome: string;
    email: string;
    telerone: string;
    perfil: string;
  } 

  export class ResponseUser{
    user: User;
    token: string    
  } 
  

  export interface jwtDecode {
    nameid: string;
    sid: string;
    IsUsuarioEmpresa: boolean;
    IsUsuarioEmpresaGestora: boolean;
    Empresa: any | null;
    IsUsuarioAdmin: boolean;
    IsUsuarioValorSaude: boolean;
    nbf: number;
    exp: number;
    iat: number;
    iss: string;
    aud: string;
  } 